import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {isCommitsEnabled} from '@github-ui/repo-app-flags'

// Commits' routes can be registered under the unified `repo` app when the
// `repo_app_commits` flag is on. The app's identity stays `commits`, but in
// that case its query keys must use `repo` so they match the running app. The
// resolver is only evaluated when a query key is built (runtime), so it can
// safely read the flag.
export const commitsAppBuilder = DataRouterApplicationBuilder.create('commits', {
  queryKeyAppName: () => (isCommitsEnabled() ? 'repo' : 'commits'),
})
